import React, { Component } from 'react'
import './Topbar.scss'
import { Link } from 'react-router-dom'
import { ReactComponent as MenuIcon } from '../Shared/icons/menu.svg'
import { ReactComponent as NotificationBell } from '../Shared/icons/bell.svg'
import LoginPopup from './LoginPopup'
import Token, { getValue } from '../Utils/Token';
import Pusher from 'pusher-js'
import config from '../Shared/config'
import Axios from 'axios'
import { calculateTimeDifference } from '../Utils/Datetime'

export default class Topbar extends Component {

    constructor(props) {
        super(props)

        this.state = {
            navExpanded: false,
            navMaxHeight: '0px',
            loggedIn: false,
            firstName: null,
            showNotifications: false,
            notifications: []
        }
    }

    componentDidMount() {
        let token = Token.getToken()
        let firstName = localStorage.getItem('firstName');
        if (token && firstName) {
            this.getNotifications()
            this.setState({
                loggedIn: true,
                firstName: firstName
            })
        } else {
            this.setState({
                loggedIn: false,
                firstName: null,
                notifications: []
            })
        }

        Pusher.logToConsole = true;

        var pusher = new Pusher('bad5d672e6a75333ea9a', {
            cluster: 'ap2'
        });

        var channel = pusher.subscribe('notifications');
        channel.bind('add', (data) => {
            this.checkAndGetUpdatedNotifications(data)
        });
    }

    // To refetch notifications if needed
    checkAndGetUpdatedNotifications = (data) => {
        let fetchNotifications = data.notificationData.find(x => x === getValue('_id'))
        if (fetchNotifications) {
            this.getNotifications()
        }
    }

    // To fetch notifications from pusher server
    getNotifications = () => {
        const url = `${config.apiUrl}/User/getNotifications`;
        Axios.get(url).then(res => {
            if (res.data) {
                if (!res.data.error) {
                    this.setState({
                        notifications: res.data.data
                    })
                } else {
                    alert(res.data.message)
                }
            }
        })
    }

    // To open/close nav in mobile mode
    toggleNav = () => {
        let menuHeight = 210
        let newExpanded = !this.state.navExpanded
        this.setState({
            navExpanded: newExpanded,
            navMaxHeight: newExpanded ? `${menuHeight}px` : '0px'
        })
    }

    // To show/hide login/signup popup
    loginPopupHandler = (val) => {
        this.loginPopup.setState({
            show: val
        }, this.toggleBodyScrolling(val))
    }

    // To enable/disable scrolling on body when a popup is opened/closed
    toggleBodyScrolling = (val) => {
        if (val) {
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove("body-no-scroll");
        }
    }

    // Logout the user
    onClickLogout = () => {
        Token.deleteToken();
        window.location.reload();
    }

    // To show/hide notifications
    toggleNotifications = (e, show) => {
        e.preventDefault()
        this.setState({
            showNotifications: show
        }, () => {
            if (show) {
                document.addEventListener('click', this.outsideClickListener); document.addEventListener('touchmove', this.outsideClickListener);
            } else {
                document.removeEventListener('click', this.outsideClickListener); document.removeEventListener('touchmove', this.outsideClickListener);
            }
        })
    }

    // helper function to hide notifications when clicked outside anywhere
    outsideClickListener = (e) => {
        if (e.target.id !== 'notificationAreaMain') {
            this.toggleNotifications(e, false)
        }
    }

    render() {
        const { type, theme } = this.props
        const { navExpanded, navMaxHeight, loggedIn, firstName } = this.state
        let headerClass = type === 'fixed' ? 'fixed' : 'fixedover'

        if (type === 'fixedover') {
            headerClass = `${headerClass} ${theme ? theme : ''}`
        }

        let navStyles = { maxHeight: navMaxHeight }
        if (!navExpanded) {
            navStyles.margin = '0px'
        }

        return (
            [
                <div key={0} className={`topbar desktop ${headerClass}`}>
                    <Link to='/' className='logocontainer'>
                        <img src={`${process.env.PUBLIC_URL}/512x512.png`} alt='logo' /> iCurious
                    </Link>
                    <div className={`navcontainer`}>
                        {
                            loggedIn ? (
                                <div className="navlink">Hey {firstName}!</div>
                            ) : (
                                    <div className="navlink" onClick={(e) => { this.loginPopupHandler(true) }}>Login</div>
                                )
                        }
                        {
                            loggedIn ? (
                                [
                                    <div className="navlink notification-link" onClick={(e) => { this.toggleNotifications(e, !this.state.showNotifications) }}>
                                        Notifications({this.state.notifications.length})
                                        <Notifications
                                            showNotifications={this.state.showNotifications}
                                            notifications={this.state.notifications}
                                        />
                                    </div>,
                                    <div className="navlink">Profile</div>
                                ]
                            ) : (
                                    null
                                )
                        }
                        <div className="navlink">About Us</div>
                        {
                            loggedIn ? (
                                <div className="navlink" onClick={this.onClickLogout}>Logout</div>
                            ) : (
                                    null
                                )
                        }
                    </div>
                </div>,

                // Mobile view
                <div key={1} className={`topbar mobile ${headerClass}`}>
                    <Link to='/' className='logocontainer'>
                        <img src={`${process.env.PUBLIC_URL}/512x512.png`} alt='logo' /> iCurious
                    </Link>

                    <div className="notification-link notificationbellicon-wrapper">
                        {
                            loggedIn ? (
                                <>
                                    <div className="circle">{this.state.notifications.length}</div>
                                    <NotificationBell className='notificationbellicon notification-link' onClick={(e) => { this.toggleNotifications(e, !this.state.showNotifications) }} />
                                    <Notifications
                                        showNotifications={this.state.showNotifications}
                                        notifications={this.state.notifications}
                                    />
                                </>
                            ) : null
                        }
                    </div>
                    <MenuIcon className='menuicon' onClick={this.toggleNav} />
                    <div className="break"></div>
                    <div ref={e => this.navcontainer = e} className={`navcontainer`} style={navStyles}>
                        {
                            loggedIn ? (
                                <div className="navlink">Hey {firstName}!</div>
                            ) : (
                                    <div className="navlink" onClick={(e) => { this.loginPopupHandler(true) }}>Login</div>
                                )
                        }
                        {
                            loggedIn ? (
                                [
                                    <div className="navlink">Profile</div>
                                ]
                            ) : (
                                    null
                                )
                        }
                        <div className="navlink">About Us</div>
                        {
                            loggedIn ? (
                                <div className="navlink" onClick={this.onClickLogout}>Logout</div>
                            ) : (
                                    null
                                )
                        }
                    </div>
                </div>,

                // Login/Signup Popup
                <LoginPopup
                    key={2}
                    ref={e => this.loginPopup = e}
                    toggleBodyScrolling={this.toggleBodyScrolling}
                />
            ]
        )
    }
}

const Notifications = ({ showNotifications, notifications }) => {
    return (
        <>
            {
                showNotifications ? (
                    <div className='notifications-main' id='notificationAreaMain'>
                        <div className='notifications-wrapper'>
                            {
                                notifications.map((item, idx) => {
                                    return (
                                        <div key={idx} className='notification-one'>
                                            <div className='title'>{item.message}</div>
                                            <div className='date-time'>{calculateTimeDifference(item.notificationDate)}</div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                ) : null
            }
        </>
    )
}

Topbar.defaultProps = {
    type: 'fixedover',
    theme: 'solid'
}
